import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DatePipe } from '@angular/common';
import { Invoice } from '../models';
import { Sepomex } from '../models/sepomex';
import { map } from 'rxjs/operators';
import { ServicesHelperService } from './services-helper.service';
import { ThrowStmt } from '@angular/compiler';

@Injectable()
export class ProviderService {
  private url: string;
  constructor(
    private httpClient: HttpClient,
    @Inject('API_URL') private apiUrl: string,
    private servicesHelperService: ServicesHelperService,
    private datepipe: DatePipe
  ) {
    this.url = apiUrl + 'service/';
  }

  getExchangeRate(date: Date): Observable<number> {
    const dateFormated = this.datepipe.transform(date, 'yyyy-MM-dd');
    const url: string = this.url + 'exchange-rate/' + dateFormated;
    const response: Observable<number> = this.httpClient.get<number>(url);
    return response;
  }

  async convertPdfToImage(blob: Blob): Promise<File> {
    const url: string = this.url + 'convert';
    const formData = new FormData();
    formData.append('formFile', blob);
    const response = await this.httpClient
      .post(url, formData, {
        responseType: 'blob',
        headers: this.servicesHelperService.getRequestOptionsFormData(),
      })
      .toPromise();

    return response as File;
  }

  getImageFromPdf(blob: Blob): Observable<File> {
    const url: string = this.url + 'convert';
    const formData = new FormData();
    formData.append('formFile', blob);

    return this.httpClient.post<Blob>(url, formData, { headers: this.servicesHelperService.getRequestOptionsFormData() }).pipe(map((x) => x as File));
  }

  getQrURL(blob: Blob): Observable<string> {
    const url: string = this.url + 'qr-url';
    const formData = new FormData();
    formData.append('formFile', blob);

    return this.httpClient.post<string>(url, formData, { headers: this.servicesHelperService.getRequestOptionsFormData() });
  }

  async xmlReader(blob: Blob): Promise<Invoice> {
    const url: string = this.url + 'invoice';

    const formData = new FormData();
    formData.append('formFile', blob);

    const response = await this.httpClient
      .post<Invoice>(url, formData, {
        responseType: 'json',
        headers: this.servicesHelperService.getRequestOptionsFormData(),
      })
      .toPromise();

    return response;
  }

  getFiscalEntityFromQR(url: string): Observable<any> {
    const response: Observable<any> = this.httpClient.get(url, {
      responseType: 'text',
      headers: this.servicesHelperService.getHeadersSIAT(),
    });

    return response;
  }

  getSEPOMEX(zip: string): Observable<Sepomex> {
    const url: string = this.url + 'sepomex/' + zip;
    const response = this.httpClient.get<Sepomex>(url);
    return response;
  }
}
